import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtService } from "app/generic/JwtService";
import { NewModalService } from "app/generic/new-modal/new-modal.service";
import { environment } from "environments/environment";


@Injectable()
export class BollettiniMeteoService extends JwtService {

  constructor(private http: HttpClient,
        public router: Router,
        public modalComponent: NewModalService) {
        super(router, modalComponent);
      }

  selectAll(): Promise<any> {

    return this.http.get(environment.apiEndpoint+ '/CentroFunzionalePortaleRest/rest/previsionimeteo/findAllMeteo', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  selectAllByAnnoReducedPeriodo(anno:number,dataDa,dataA):Promise<any>{
    
    return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/previsionimeteo/findAllByAnnoReduced/'+anno + "?dataDa=" + dataDa + "&dataA="+dataA, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  

  selectAllByAnnoReduced(anno:number):Promise<any>{
    
    return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/previsionimeteo/findAllByAnnoReduced/'+anno, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }


  findByIdBollettino(idBollettino: any): Promise<any> {

    return this.http.get(environment.apiEndpoint+ '/CentroFunzionalePortaleRest/rest/previsionimeteo/findByIdBollettino/' + idBollettino, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  getPDFbyte(idBollettino:any):Promise<any>{
      
    return this.http.get(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/bollettinometeo/getPDF/'+idBollettino, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }


  findLastMeteo(): Promise<any> {

    return this.http.get(environment.apiEndpoint+ '/CentroFunzionalePortaleRest/rest/previsionimeteo/findLastMeteo/', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }


}